module.exports = __webpack_public_path__ + "static/media/Google Pixel 3 - Just Black.5684aceb.png";